import { FunctionComponent, PropsWithChildren } from "react";

export type ComponentIdInjectorProps = PropsWithChildren<{
  id?: string;
}>;

export const ComponentIdInjector: FunctionComponent<
  ComponentIdInjectorProps
> = ({ id, children }) => (
  <>
    {id && (
      <div
        id={id}
        style={{ position: "absolute", visibility: "hidden", height: 0 }}
      />
    )}
    {children}
  </>
);
